// Konusma gecmisi listesi icin saf yardimcilar. Backend son 3 mesaji yeniden
// eskiye gonderir; yine de tarihe gore siralayip en yeni metinli mesaji aliriz.

const byNewest = (a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();

function pickPreview(messages) {
    const withText = (messages || []).filter((m) => m && typeof m.description === "string" && m.description.trim());
    if (!withText.length) return null;
    const newest = withText.slice().sort(byNewest)[0];
    return { text: newest.description.trim(), mine: newest.messageType === "visitor" };
}

function titleCase(name) {
    return String(name || "")
        .trim()
        .toLocaleLowerCase("tr")
        .split(/\s+/)
        .map((w) => w.charAt(0).toLocaleUpperCase("tr") + w.slice(1))
        .join(" ");
}

function conversationTitle(chat, t) {
    const aiTitle = chat && chat.ai && typeof chat.ai.title === "string" ? chat.ai.title.trim() : "";
    if (aiTitle) return aiTitle;
    const users = (chat && chat.users) || [];
    const names = users.map((u) => titleCase(u && u.name)).filter(Boolean);
    return names.length ? names.join(", ") : t("supportTeam");
}

function initialOf(name) {
    const s = String(name || "").trim();
    return s ? s.charAt(0).toLocaleUpperCase("tr") : "*";
}

const UNITS = [
    ["year", 31536000],
    ["month", 2592000],
    ["week", 604800],
    ["day", 86400],
    ["hour", 3600],
    ["minute", 60],
];

function relativeTime(date, locale, now = new Date()) {
    const diff = Math.round((new Date(date).getTime() - now.getTime()) / 1000);
    const lang = String(locale || "en").split("-")[0];
    let rtf;
    try {
        rtf = new Intl.RelativeTimeFormat(lang, { numeric: "auto" });
    } catch (e) {
        rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
    }
    for (const [unit, secs] of UNITS) {
        if (Math.abs(diff) >= secs) return rtf.format(Math.trunc(diff / secs), unit);
    }
    return rtf.format(0, "second");
}

module.exports = { pickPreview, conversationTitle, initialOf, relativeTime };



// WEBPACK FOOTER //
// ./src/utils/chatHistoryList.js